export const UploadSources = {
  localFile: "localFile",
  polygonSelect: "polygonSelect",
  edit: "edit",
};
